<template>
  <DynamicForm
    dynamicFormType="prcm"
    :answerableId="attendance.id"
    answerableType="Attendance"
    :disabled="attendanceEsigned"
  />
</template>

<script>
  import DynamicForm from "@/components/dynamic_form/index.vue";

  export default {
    name: "PRCM",
    components: {
      DynamicForm,
    },
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
  };
</script>

<style lang="scss" scoped></style>
